<!--Wird eingebunden-->
<template>
  <div class="app-activation-country-input">
    <b-form-group label="Identifikationsdaten" label-class="visually-hidden">
      <b-form-group class="nationality-group" label-for="nationality">
        <b-row>
          <b-col md="" sm="12">
            <label class="mandatory d-inline-block" for="nationality"><slot name="nationalityLabel">Staatsangehörigkeit</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-select
              id="nationality"
              v-model="nationality"
              :options="nationalityOptions"
              required
              @input="$v.nationality.$touch"
              :state="isValid('nationality')"
              @change="resetIdentCard()"
            ></b-form-select>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="ident-card-group" label-for="identCard">
        <p v-if="disablePassport" class="text-danger"><slot name="noIdentificationPossibleTxt">Eine Identifikation ist mit Ihrer Staatsangehörigkeit leider nicht möglich</slot></p>
        <b-row>
          <b-col md="" sm="12">
            <label class="mandatory d-inline-block" for="identCard"><slot name="identCardLabel">Ausweistyp</slot></label>
          </b-col>
          <b-col md="" sm="12">
            <b-form-select
              id="identCard"
              v-model="identCard"
              :options="identityCardOptions"
              required
              :disabled="disablePassport"
              @input="$v.identCard.$touch"
              @change="resetIdent()"
              :state="isValid('identCard')"
            ></b-form-select>
          </b-col>
        </b-row>
      </b-form-group>
      <b-row>
        <b-form-radio-group v-model="identType_" required
                            class="ident-type-group"
                            @input="$v.identType.$touch"
                            :state="isValid('identType')">
          <b-col cols="12">
            <b-form-radio id="videoident" :disabled="disableVideoIdent" name="videoident" value="video">
              <slot name="videoidentLabelTxt">Videoanruf</slot>
            </b-form-radio>
          </b-col>
          <b-col cols="12">
            <b-form-radio id="postident" :disabled="disablePostalIdentification" name="postident" value="store">
              <slot name="postidentLabelTxt">Postfiliale</slot>
            </b-form-radio>
          </b-col>
        </b-form-radio-group>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox
            id="dataMatchIdent"
            v-model="dataMatchIdent_"
            class="data-match-ident-group"
            required
            @input="this.checkFormValidation"
            :state="isValid('dataMatchIdent')"
          >
            <slot name="dataMatchIdentLabelTxt">Daten stimmen mit dem Ausweisdokument überein</slot>
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import isValid from '@/mixins/isValid'
import syncProperty from '@/mixins/syncProperty'
import preFilledInput from '@/mixins/preFilledInput'

export default {
  name: 'InputCountryData',
  data () {
    return {
      allIdentMethods: {
        identTypes: []
      }
    }
  },
  computed: {
    nationalityOptions: function () {
      return this.allIdentMethods.identTypes.map(identType => {
        return {
          value: identType,
          text: identType.name
        }
      })
    },
    identityCardOptions: function () {
      const identityCardOptions = this.nationality?.passports || []
      const filteredOptions = identityCardOptions.map(passport => {
        return {
          value: passport,
          text: passport.name
        }
      }).filter(passport => {
        return (passport.value.identMethods.includes('store') || passport.value.identMethods.includes('video'))
      })
      if (filteredOptions.length === 0) {
        return [this.disabledPassportObject].map(passport => {
          return {
            value: passport,
            text: passport.name
          }
        })
      } else {
        return filteredOptions
      }
    },
    currentIdents: function () {
      return this.identCard?.identMethods || []
    },
    disablePassport: function () {
      if (!this.nationality) {
        return false
      }
      return this.identityCardOptions.filter(passportOption => {
        const passport = passportOption.value
        return passport.identMethods.includes('store') || passport.identMethods.includes('video')
      }).length === 0
    },
    disableVideoIdent: function () {
      if (this.disablePassport) {
        return true
      }
      return this.currentIdents.includes('video') === false
    },
    disablePostalIdentification: function () {
      if (this.disablePassport) {
        return true
      }
      return this.currentIdents.includes('store') === false
    },
    defaultNationality: function () {
      return this.nationalityOptions.find(nationality => {
        return nationality.value.iso3 === this.defaultNationalityKey
      })?.value
    },
    defaultIdentCard: function () {
      return this.identityCardOptions.find(identCard => {
        return identCard.value.key === this.defaultIdentCardKey
      })?.value
    },
    disabledPassportObject: function () {
      return { __typename: 'NoPassport', name: '---', key: 'N/A', identMethods: [] }
    }
  },
  watch: {
    '$v.$invalid': function (newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  methods: {
    checkFormValidation () {
      this.$v.$touch()
      this.$emit('validation')
      return this.$v.dataMatchIdent.$touch
    },
    resetIdentCard () {
      this.identCard = this.identityCardOptions[0].value
      this.resetIdent()
    },
    resetIdent () {
      if (this.identType_ !== null) {
        if ((this.identType_ === 'store' && this.disablePostalIdentification) || (this.identType_ === 'video' && this.disableVideoIdent)) {
          this.identType_ = null
        }
      } else {
        if (this.disableVideoIdent && this.disablePostalIdentification) {
          this.identType_ = null
        } else if (this.disableVideoIdent) {
          this.identType_ = 'store'
        } else if (this.disablePostalIdentification) {
          this.identType_ = 'video'
        } else {
          this.identType_ = 'video'
        }
      }
    }
  },
  mixins: [
    syncProperty('identType', 'identType_'),
    syncProperty('dataMatchIdent', 'dataMatchIdent_'),
    preFilledInput('nationality', 'defaultNationality', 'nationality'),
    preFilledInput('identCard', 'defaultIdentCard', 'identCard'),
    validationMixin,
    isValid
  ],
  mounted () {
    this.$emit('update:invalid', this.$v.$invalid)
  },
  validations () {
    return {
      identCard: {
        required,
        validPassport: {
          validPassportRequired: (value, vm) => {
            if (vm.__typename === 'NoPassport') {
              return false
            }
            return true
          }
        }
      },
      nationality: {
        required
      },
      identType: {
        required
      },
      dataMatchIdent: {
        sameAs: sameAs(() => true)
      }
    }
  },
  props: {
    defaultNationalityKey: {
      type: String,
      default: 'DEU'
    },
    defaultIdentCardKey: {
      type: String,
      default: 'IDC'
    },
    operationName: {
      type: String,
      default: 'activation'
    }
  },
  apollo: {
    allIdentMethods: function () {
      return wrapQuery(gql`query ${this.operationName} {
        allIdentMethods {
          identTypes {
            iso2,
            iso3,
            name,
            passports {
              identMethods,
              key,
              name
            }
          }
        }
      }`, this, 'allIdentMethods',
      {},
      () => {},
      { fetchPolicy: 'cache-first' })
    }
  }
}
</script>
